import React from 'react';
import { Box } from '@mui/material';
import useStyles from './styles';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const Loader = ({ label, labelStyles, loaderContainerStyle = {} }) => {
	const classes = useStyles();
	return (
		<Box className={classes.loaderContainer} style={loaderContainerStyle}>
			<Typography
				className={classes.heading}
				fontWeight={600}
				variant="h6"
				style={labelStyles || {}}
			>
				{label}
			</Typography>
			<CircularProgress
				style={{
					color: '#FC4B58',
					marginTop: '2rem'
				}}
			/>
		</Box>
	);
};

export default Loader;
